'use strict';
import React from 'react';

var NotFoundPage = React.createClass({
    displayName: 'NotFoundPage',
    mixins: [],
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    componentDidMount() {

        this.context.router.transitionTo('landing-page');
    },
    render() {
        return (<div>NotFoundPage</div>);
    }
});

module.exports = NotFoundPage;



// WEBPACK FOOTER //
// ./app/pages/notFound/index.jsx